import { feature, flattenFeatures } from "@protontech/autofill/features/feature";
import {
  fieldAttrs,
  fieldAttrUsername,
  fieldAutocompleteEmail,
  fieldAutocompleteOff,
  fieldAutocompleteUsername,
  fieldCC,
  fieldEmailMatch,
  fieldFeats,
  fieldIdentity,
  fieldLabel,
  fieldPrevInput,
  fieldSearch,
  fieldText,
} from "@protontech/autofill/features/v1/abstract.field";
import { any } from "@protontech/autofill/utils/combinators";
import { matchUsername, matchUsernameOutlier } from "@protontech/autofill/utils/re";

export const textUsername = feature("textUsername", { fieldText }, (p) => matchUsername(p.fieldText));
export const labelUsername = feature("labelUsername", { fieldLabel }, (p) => matchUsername(p.fieldLabel));
export const username = feature("username", { fieldAttrUsername, textUsername, labelUsername }, (p) => p.attrUsername || p.textUsername || p.labelUsername);
export const outlierAttrs = feature("outlierAttrs", { fieldAttrs }, (p) => any(matchUsernameOutlier)(p.fieldAttrs));
export const outlierText = feature("outlierText", { fieldText }, (p) => matchUsernameOutlier(p.fieldText));
export const outlierLabel = feature("outlierLabel", { fieldLabel }, (p) => matchUsernameOutlier(p.fieldLabel));
export const outlierEmail = feature("outlierEmail", { username, emailMatch: fieldEmailMatch }, (p) => !p.username && p.emailMatch);
export const outlier = feature("outlier", { outlierAttrs, outlierText, outlierLabel, outlierEmail }, (p) => p.outlierAttrs || p.outlierText || p.outlierLabel || p.outlierEmail);
export const maybeCandidate = feature("maybeCandidate", { outlier, username }, (p) => !(p.outlier || p.username));
export const firstFormField = feature("firstFormField", { fieldPrevInput }, (p) => p.fieldPrevInput === null);
export const firstLoginFormField = feature("firstLoginFormField", { fieldFeats, firstFormField, maybeCandidate }, (p) => p.fieldFeats.isFormLogin && p.firstFormField && p.maybeCandidate);

export const usernameFeatures = flattenFeatures({
  fieldAttrUsername,
  fieldAutocompleteEmail,
  fieldAutocompleteOff,
  fieldAutocompleteUsername,
  fieldCC,
  fieldIdentity,
  fieldSearch,
  firstLoginFormField,
  labelUsername,
  outlierAttrs,
  outlierEmail,
  outlierLabel,
  outlierText,
  textUsername,
});
